export const CONTACT_MODULE_NAME = "Liên hệ (đối tác)";
export const CASH_FLOW_MODULE_URL = "/sales/cash-flow";
export const CONTACT_API_PATH = "/v1/contact";
